import { StoryboardDateUtils } from '../../../settings/dashboard-configs/utils';
import { SingleValueTimeSelection, TimeSelectionType } from '../../../types';

export const getNewGradRecruitmentTimeSelection = (
  storyboardDateUtils: StoryboardDateUtils
): SingleValueTimeSelection => {
  return {
    type: TimeSelectionType.CalendarYearSingleValueByMonths,
    input: {
      start: '2025-01-01',
      end: '2026-03-31',
    },
  };
};

export const getMidCareerRecruitmentTimeSelection = (
  storyboardDateUtils: StoryboardDateUtils
): SingleValueTimeSelection => {
  return {
    type: TimeSelectionType.CalendarYearSingleValueByMonths,
    input: {
      start: '2025-01-01',
      end: '2025-12-31',
    },
  };
};

export const getAllRecruitmentTimeSelection = (
  storyboardDateUtils: StoryboardDateUtils
): SingleValueTimeSelection => {
  return {
    type: TimeSelectionType.CalendarYearSingleValueByMonths,
    input: {
      start: '2025-01-01',
      end: '2026-03-31',
    },
  };
};
